
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">


  <div class="Column-new colmd3" *ngIf="ShowList">

    <div class="card ms-office-card padding-left-5px padding-right-5px">

      <div class="position-fixed-Activities5">

        <div class="ms-sidebar-header-box">
          <h5 class="ms-sidebar-header-title">
            <i class="far fa-calendar-check"></i> Appointments 
          </h5>
        </div>
        <div class="card-body padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px background-color-e4">
          <div class="row margin-left-0px margin-right-0px">

            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-left-0px">
              <div class="row " hidden>
                <div class="col-md-11">
                  <label class="margin-bottom-0px font-weight-normal font-size-14">Select Branch</label>
                </div>
                <!--<div class="col-md-2">
            <a (click)="docedit()" class="nav-link-hand education-navlink" title="Edit Plan">
              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
            </a>
          </div>-->
              </div>





              <div class="row margin-left-0px  margin-bottom-5px">
                <div class="col-md-12 padding-left-5px my-profile-form">


                  <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode}}
                                           (keyChange)="Roleassign($event)"
                                           [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                           required>
                  </CustomDataByRequestType>
                </div>
              </div>







            </div>

          </div>
          <div class="row padding-top-5px padding-bottom-10px margin-right-0px margin-left-5px">
            <!--<input type="search" class="form-control padding-bottom-2px width-230px" placeholder="Search....">-->
            <div class="col-md-12 padding-left-0px">
              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
            </div>


          </div>
          <div class="height-col padding-bottom-122px">
            <div class="chatsd product-chart-wrapper agreement-chart-wrapper scroll padding-lrt ">
              <div *ngIf="isRequesting">

                <div class="loader-text">
                  <div class="loader-text2">

                    <div class="lds-facebook">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                    <div class="margin-top-20px margin-left-5px">
                      <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                    </div>
                    <!--Loading Please Wait...-->
                  </div>
                </div>


              </div>
              <div *ngIf="!isRequesting">
                <div class="row ms-doctor-item margin-left-5px margin-right-5px nav-link-hand padding-bottom-0px padding-top-0px"
                     [class.active]="SelectedDoctorData && SelectedDoctorData.DoctorCode === l.DoctorCode"
                     *ngFor="let l of pdata" (click)="DoctorListItemSelected(l)">
                  <div class="col-md-12 margin-top-5px margin-bottom-5px">

                    <div class="row align-items-center">
                      <div class="col-md-3">
                        <div class="row">
                          <a class="nav-link-hand margin-left-5px">
                            <img class="ms-doctor-avatar" src="DR SITARAM.jpg">
                          </a>
                        </div>
                      </div>
                      <div class="col-md-9 padding-left-0px">
                        <div class="row margin-left-0px">
                          <label class="ms-doctor-name td-elipsis-appoinment1">{{l.Prefix}}{{l.DisplayName}}</label>
                        </div>

                        <div class="row margin-left-0px">
                          <label class="ms-doctor-specialty">{{l.Specialty}}</label>
                        </div>

                      </div>

                    </div>






                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>




  <div class="column-left-80 padding-left-5px padding-top-5px" *ngIf="SelectedDoctor">

    <div class="card ms-office-card">
      <div class="position-fixed-Activities80">
        <div class="card-header ms-doctor-banner border-bottom-0px">
          <div class="row align-items-center width-100pe margin-left-0px margin-right-0px">
            <div class="col-md-5 padding-left-0px">
              <div class="ms-banner-doctor-group">
                <img class="ms-banner-avatar" src="DR SITARAM.jpg">
                <div>
                  <h5 class="ms-banner-title">{{SelectedDoctorData.DisplayName}}</h5>
                  <span class="ms-banner-subtitle">{{SelectedDoctorData.Specialty}} &bull; {{BranchName}}</span>
                </div>
              </div>
            </div>
            <div class="offset-md-1 col-md-4 col-sm-4 padding-right padding-left-0px margin-top-auto margin-bottom-auto">
              <div class="ms-date-navigator">
                <button class="ms-date-nav-btn" (click)="DecrementDate()" title="Previous Date">
                  <i class="fas fa-chevron-left"></i>
                </button>

                <div class="date-form display-inline-block">
                  <input class="ms-date-input" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                         (ngModelChange)="dataChanged($event)">
                  <a (click)="d.toggle()" class="nav-link-hand text-white margin-left-4px">
                    <i class="far fa-calendar-alt"></i>
                  </a>
                </div>

                <button class="ms-date-nav-btn" (click)="IncrementDate()" title="Next Date">
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div class="col-md-2 text-right" *canUserAccess="['HL_SCH_CALENDAR_VIEW']">
              <div class="display-inline margin-right-6px">
                <button class="ms-tool-btn" (click)="SwitchView()" title="Toggle View">
                  <i class="far fa-calendar-alt"></i>
                </button>
              </div>
              <div class="display-inline">
                <button *ngIf="CalendarView" (click)="RefresAppts()" class="ms-tool-btn" title="Refresh">
                  <i class="fas fa-redo"></i>
                </button>
              </div>           
            </div>
          </div>
        </div>

        <div class="card-body background-white padding-left-0px padding-top-5px">
          <div class=" padding-lrt " *ngIf="DailyView">

            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px">

              <div class="ms-daily-toolbar">
                <div class="display-flex align-items-center">
                  <span class="ms-daily-title">
                    Appointments of the day
                  </span>
                  <span *ngIf="CurrentDoctorAppointmentsByDoctorcodeController" class="ms-count-badge">
                    {{pdata1.length}}
                  </span>
                </div>
            
                <div class="width-220px">
                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange1($event)"></search-list>
                </div>

                <div *ngIf="ProviderSlots">
                  <select class="form-control Appoinment padding-left-5px padding-right-5px border-radius-6px" (change)="onChange($event.target.value)" [(ngModel)]="selectedGroup">
                    <option selected="selected" value="">Select Time Slot...</option>
                    <option *ngFor="let p of ProviderSlots" [ngValue]="p">
                      {{p.StartDate | date: 'hh:mm a'}}
                    </option>
                  </select>
                </div>

                <div>
                  <button type="button" (click)="regpatientmodal(selectedGroup)"
                          class="ms-btn-primary"
                          title="Click here to book a slot">
                    <i class="fas fa-plus"></i> Book Slot
                  </button>
                </div>

                <div>
                  <button (click)="RefreshAll()" class="btn btn-light border-radius-50p padding-6px" type="button" title="Refresh">
                    <i class="fas fa-redo text-primary"></i>
                  </button>
                </div>

              </div>
            
              <div class="padding-top-10px">
                <div class="chatsd product-chart-wrapper product-chat-height-527px agreement-chart-wrapper ps padding-lrt ">
                  <div *ngIf="isLoading">

                    <div class="loader-text">
                      <div class="loader-text2">

                        <div class="lds-facebook">
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        <div class="margin-top-20px margin-left-5px">
                          <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                        </div>
                        <!--Loading Please Wait...-->
                      </div>
                    </div>


                  </div>

                  <div *ngIf="!isLoading">
                    <div *ngIf="pdata1">
                      <div class="padding-top-5px">
                        <div class="ms-patient-row-card" *ngFor="let l of pdata1">
                          <!-- Left Section: Time Badge, Avatar & Patient Details -->
                          <div class="ms-row-patient-info">
                            <div class="ms-row-time-badge">
                              {{l.AppointmentDate | date: 'hh:mm a'}}
                            </div>

                            <img class="ms-row-avatar" [src]="l.PatientImageFile || 'dummy.jpg'" onError="this.src='dummy.jpg';">

                            <div class="ms-patient-details-box">
                              <h6 class="ms-patient-row-name">{{l.PatientName}}</h6>
                              <div class="ms-patient-row-meta">
                                <span *ngIf="l.Telephone1"><i class="fas fa-phone margin-right-4px"></i> {{l.Telephone1}}</span>
                                <span class="ms-patient-code-tag" *ngIf="l.PatientFormattedCode">{{l.PatientFormattedCode}}</span>
                              </div>
                            </div>
                          </div>

                          <!-- Center Section: Status Checkbox Steppers -->
                          <div class="ms-row-status-stepper" *ngIf="!l.NoShowStatus">
                            <div class="ms-status-check-item">
                              <span>Check-In</span>
                              <input type="checkbox" (change)="onSubmit(l,'CHECKIN', $event)" [(ngModel)]="l.CheckInStatus">
                            </div>
                            <div class="ms-status-check-item">
                              <span>Enc-Start</span>
                              <input type="checkbox" name="1.EncounterStartStatus" (change)="onSubmit(l,'ENCSTART', $event)" [(ngModel)]="l.EncounterStartStatus">
                            </div>
                            <div class="ms-status-check-item">
                              <span>Enc-end</span>
                              <input type="checkbox" name="1.EncounterEndStatus" (change)="onSubmit(l,'ENCEND', $event)" [(ngModel)]="l.EncounterEndStatus">
                            </div>
                            <div class="ms-status-check-item">
                              <span>Check-out</span>
                              <input type="checkbox" name="1.CheckOutStatus" (change)="onSubmit(l,'CHECKOUT', $event)" [(ngModel)]="l.CheckOutStatus">
                            </div>
                          </div>

                          <div class="ms-row-status-stepper" *ngIf="!l.CheckInStatus && l.NoShowStatus">
                            <div class="ms-status-check-item">
                              <span>No Show</span>
                              <input type="checkbox" name="1.NoShowStatus" (change)="onSubmit(l,'NOSHOW', $event)" [(ngModel)]="l.NoShowStatus">
                            </div>
                          </div>

                          <!-- Right Section: Visit Info & Action Pill Buttons -->
                          <div class="ms-row-actions-group">
                            <div class="display-flex flex-direction-column align-items-end" *ngIf="l.BillNo || l.VisitType">
                              <span class="ms-patient-code-tag margin-bottom-2px" *ngIf="l.BillNo">{{l.BillNo}}</span>
                              <span class="badge badge-success font-size-11px" *ngIf="l.VisitType">{{l.VisitType}}</span>
                            </div>

                            <button type="button" (click)="Profile(l)" class="ms-action-pill-btn" title="View Patient Profile"
                                    *ngIf="l.AppointmentStatus=='CHECKIN' || l.AppointmentStatus=='CHECKOUT' || l.AppointmentStatus=='ENCSTART' || l.AppointmentStatus=='ENCEND'">
                              <i class="fas fa-user text-primary"></i> Profile
                            </button>

                            <button type="button" (click)="Addbill(l)" class="ms-action-pill-btn btn-bill" title="Add Bill"
                                    *ngIf="l.AppointmentStatus=='CHECKIN' || l.AppointmentStatus=='CHECKOUT' || l.AppointmentStatus=='ENCSTART' || l.AppointmentStatus=='ENCEND'">
                              <i class="fas fa-plus"></i> Add Bill
                            </button>

                            <button type="button" (click)="cancel()" class="ms-action-pill-btn btn-cancel" title="Cancel Appointment"
                                    *ngIf="l.AppointmentStatus=='Pending'">
                              <i class="fas fa-times"></i> Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


            </div>


          </div>
          <div class="padding-lrt" *ngIf="CalendarView">
            <!--showing calendar for 7 days.... yeah-->
            <!--<CalendarWeekViewComponent [ProviderCode]=""
                                       [FacilityCode]=""
                                       [FromDate]=""
                                       ></CalendarWeekViewComponent>-->
            <!--<calendarweekview>

            </calendarweekview>-->
            <div class="col-md-12 padding-left-0px padding-right-0px height-col padding-bottom-122px">

              <div class="ms-calendar-header-row margin-left-0px margin-right-0px">
                <div class="col-md-1 ms-time-gutter-cell">
                  TIME
                </div>
                <div class="col-md-11">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-2 padding-left-2px padding-right-2px" *ngFor="let c of CalendarDays">
                      <div class="ms-day-pill-card" [class.active]="c === SelectedFromDate" (click)="GotoDailyView(c)">
                        <span class="ms-day-name">{{c | date:'EEE'}}</span>
                        <span class="ms-day-num">{{c | date:'dd MMM'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps padding-lrt ">
                <div class="row">
                  <div class="col-12" *ngIf="TLKeys.length > 0">

                    <div *ngFor="let key of TLKeys">
                      <div class="row margin-left-0px border-top-2px-e4 min-height-30 calendartime-hover align-items-center">
                        <div class="col-md-1 ms-time-gutter-cell">
                          {{TL.get(key)}}
                        </div>
                        <div class="col-md-11">
                          <div class="row min-height-30">
                            <div class="col-md-2 border-left-2px-e4">
                              <!-- show + button on mouse hover... -->
                              <!-- day 1 -->

                              <div class="row  div-show-effect-parent">
                                <div class="col-md-12">
                                  <div class="row" *ngFor="let booked of GetApptsOfDay(0, key)">
                                    <div class="col-md-1 padding-left-2px padding-right-0px">
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked In"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKIN'">
                                        <i class="fas fa-circle color-Appt-Checkin  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Pending"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='Pending'">
                                        <i class="fas fa-circle color-gray  nav-link-hand font-size-10px">
                                        </i>
                                      </label>

                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc Start"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCSTART'">
                                        <i class="fas fa-circle color-Appt-Encstart  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc End"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCEND'">
                                        <i class="fas fa-circle color-Appt-EncEnd  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked Out"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKOUT'">
                                        <i class="fas fa-circle color-Appt-Checkout  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="No Show"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='NOSHOW'">
                                        <i class="fas fa-circle color-Appt-Noshow  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                    </div>
                                    <div class="col-md-11 padding-left-0px padding-right-0px">
                                      <label (click)="Sel_ApptUpdtStatus(booked)" class="margin-bottom-0px nav-link-hand font-size-12px ptname-hover">
                                        {{booked.PatientName}}
                                      </label>
                                    </div>

                                  </div>
                                </div>
                                <div class="col-md-12 text-align-center padding-left-0px padding-right-0px show-child-on-parent-over"
                                     (click)="TryBookAppt(0, key)">
                                  <button type="button" class="ms-cell-add-btn" title="New Appointment"><i class="fas fa-plus"></i> New</button>
                                </div>
                              </div>

                            </div>
                            <div class="col-md-2 border-left-2px-e4">
                              <!-- day 1 -->

                              <div class="row  div-show-effect-parent">
                                <div class="col-md-12">
                                  <div class="row" *ngFor="let booked of GetApptsOfDay(1, key)">
                                    <div class="col-md-1 padding-left-2px padding-right-0px">
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked In"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKIN'">
                                        <i class="fas fa-circle color-Appt-Checkin  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Pending"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='Pending'">
                                        <i class="fas fa-circle color-gray  nav-link-hand font-size-10px">
                                        </i>
                                      </label>

                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc Start"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCSTART'">
                                        <i class="fas fa-circle color-Appt-Encstart  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc End"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCEND'">
                                        <i class="fas fa-circle color-Appt-EncEnd  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked Out"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKOUT'">
                                        <i class="fas fa-circle color-Appt-Checkout  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="No Show"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='NOSHOW'">
                                        <i class="fas fa-circle color-Appt-Noshow  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                    </div>
                                    <div class="col-md-11 padding-left-0px padding-right-0px">
                                      <label (click)="Sel_ApptUpdtStatus(booked)" class="margin-bottom-0px nav-link-hand font-size-12px ptname-hover">
                                        {{booked.PatientName}}
                                      </label>
                                    </div>

                                  </div>
                                </div>
                                <div class="col-md-12 text-align-center padding-left-0px padding-right-0px show-child-on-parent-over"
                                     (click)="TryBookAppt(1, key)">
                                  <button type="button" class="ms-cell-add-btn" title="New Appointment"><i class="fas fa-plus"></i> New</button>
                                </div>
                              </div>

                              <!--<div class="row" *ngFor="let booked of GetApptsOfDay(1, key)">
                    <label class="margin-bottom-0px font-size-12px">{{booked.PatientName}}</label>
                  </div>-->

                            </div>
                            <div class="col-md-2 border-left-2px-e4">
                              <!-- day 1 -->
                              <div class="row  div-show-effect-parent">
                                <div class="col-md-12">
                                  <div class="row" *ngFor="let booked of GetApptsOfDay(2, key)">
                                    <div class="col-md-1 padding-left-2px padding-right-0px">
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked In"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKIN'">
                                        <i class="fas fa-circle color-Appt-Checkin  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Pending"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='Pending'">
                                        <i class="fas fa-circle color-gray  nav-link-hand font-size-10px">
                                        </i>
                                      </label>

                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc Start"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCSTART'">
                                        <i class="fas fa-circle color-Appt-Encstart  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc End"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCEND'">
                                        <i class="fas fa-circle color-Appt-EncEnd  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked Out"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKOUT'">
                                        <i class="fas fa-circle color-Appt-Checkout  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="No Show"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='NOSHOW'">
                                        <i class="fas fa-circle color-Appt-Noshow  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                    </div>
                                    <div class="col-md-11 padding-left-0px padding-right-0px">
                                      <label (click)="Sel_ApptUpdtStatus(booked)" class="margin-bottom-0px nav-link-hand font-size-12px ptname-hover">
                                        {{booked.PatientName}}
                                      </label>
                                    </div>

                                  </div>
                                </div>
                                <div class="col-md-12 text-align-center padding-left-0px padding-right-0px show-child-on-parent-over"
                                     (click)="TryBookAppt(2, key)">
                                  <button type="button" class="ms-cell-add-btn" title="New Appointment"><i class="fas fa-plus"></i> New</button>
                                </div>
                              </div>

                            </div>
                            <div class="col-md-2 border-left-2px-e4">
                              <!-- day 1 -->
                              <div class="row  div-show-effect-parent">
                                <div class="col-md-12">
                                  <div class="row" *ngFor="let booked of GetApptsOfDay(3, key)">
                                    <div class="col-md-1 padding-left-2px padding-right-0px">
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked In"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKIN'">
                                        <i class="fas fa-circle color-Appt-Checkin  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Pending"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='Pending'">
                                        <i class="fas fa-circle color-gray  nav-link-hand font-size-10px">
                                        </i>
                                      </label>

                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc Start"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCSTART'">
                                        <i class="fas fa-circle color-Appt-Encstart  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc End"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCEND'">
                                        <i class="fas fa-circle color-Appt-EncEnd  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked Out"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKOUT'">
                                        <i class="fas fa-circle color-Appt-Checkout  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="No Show"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='NOSHOW'">
                                        <i class="fas fa-circle color-Appt-Noshow  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                    </div>
                                    <div class="col-md-11 padding-left-0px padding-right-0px">
                                      <label (click)="Sel_ApptUpdtStatus(booked)" class="margin-bottom-0px nav-link-hand font-size-12px ptname-hover">
                                        {{booked.PatientName}}
                                      </label>
                                    </div>

                                  </div>
                                </div>
                                <div class="col-md-12 text-align-center padding-left-0px padding-right-0px show-child-on-parent-over"
                                     (click)="TryBookAppt(3, key)">
                                  <button type="button" class="ms-cell-add-btn" title="New Appointment"><i class="fas fa-plus"></i> New</button>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-2 border-left-2px-e4">
                              <!-- day 1 -->
                              <div class="row  div-show-effect-parent">
                                <div class="col-md-12">
                                  <div class="row" *ngFor="let booked of GetApptsOfDay(4, key)">
                                    <div class="col-md-1 padding-left-2px padding-right-0px">
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked In"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKIN'">
                                        <i class="fas fa-circle color-Appt-Checkin  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Pending"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='Pending'">
                                        <i class="fas fa-circle color-gray  nav-link-hand font-size-10px">
                                        </i>
                                      </label>

                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc Start"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCSTART'">
                                        <i class="fas fa-circle color-Appt-Encstart  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc End"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCEND'">
                                        <i class="fas fa-circle color-Appt-EncEnd  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked Out"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKOUT'">
                                        <i class="fas fa-circle color-Appt-Checkout  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="No Show"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='NOSHOW'">
                                        <i class="fas fa-circle color-Appt-Noshow  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                    </div>
                                    <div class="col-md-11 padding-left-0px padding-right-0px">
                                      <label (click)="Sel_ApptUpdtStatus(booked)" class="margin-bottom-0px nav-link-hand font-size-12px ptname-hover">
                                        {{booked.PatientName}}
                                      </label>
                                    </div>

                                  </div>
                                </div>
                                <div class="col-md-12 text-align-center padding-left-0px padding-right-0px show-child-on-parent-over"
                                     (click)="TryBookAppt(4, key)">
                                  <button type="button" class="ms-cell-add-btn" title="New Appointment"><i class="fas fa-plus"></i> New</button>
                                </div>
                              </div>

                            </div>
                            <div class="col-md-2 border-left-2px-e4">
                              <!-- day 1 -->
                              <div class="row  div-show-effect-parent margin-right-0px">
                                <div class="col-md-12">
                                  <div class="row" *ngFor="let booked of GetApptsOfDay(5, key)">
                                    <div class="col-md-1 padding-left-2px padding-right-0px">
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked In"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKIN'">
                                        <i class="fas fa-circle color-Appt-Checkin  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Pending"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='Pending'">
                                        <i class="fas fa-circle color-gray  nav-link-hand font-size-10px">
                                        </i>
                                      </label>

                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc Start"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCSTART'">
                                        <i class="fas fa-circle color-Appt-Encstart  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Enc End"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='ENCEND'">
                                        <i class="fas fa-circle color-Appt-EncEnd  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="Checked Out"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='CHECKOUT'">
                                        <i class="fas fa-circle color-Appt-Checkout  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                      <label data-toggle="tooltip" data-placement="bottom" title="No Show"
                                             class="margin-bottom-0px"
                                             *ngIf="booked.AppointmentStatus=='NOSHOW'">
                                        <i class="fas fa-circle color-Appt-Noshow  nav-link-hand font-size-10px">
                                        </i>
                                      </label>
                                    </div>
                                    <div class="col-md-11 padding-left-0px padding-right-0px">
                                      <label (click)="Sel_ApptUpdtStatus(booked)" class="margin-bottom-0px nav-link-hand font-size-12px ptname-hover">
                                        {{booked.PatientName}}
                                      </label>
                                    </div>

                                  </div>
                                </div>
                                <div class="col-md-12 text-align-center padding-left-0px padding-right-0px show-child-on-parent-over"
                                     (click)="TryBookAppt(5, key)">
                                  <button type="button" class="ms-cell-add-btn" title="New Appointment"><i class="fas fa-plus"></i> New</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="col-md-2 background-2" *ngFor="let day of AppointmentsInWeek" hidden>
                    <label>{{day.StartDate}}</label>
                    <div class="row" *ngFor="let booked of CurrentDoctorAppointmentsByDoctorcodeController">
                      {{booked.PatientName}} - {{booked.AppointmentDate}}
                    </div>
                    <div class="row " *ngFor="let slot of day.DaySlots">
                      <label>{{slot.AppointmentTime}}</label>

                      <div class="row" *ngFor="let booked of slot.FilledSlots">
                        {{booked.PatientName}}
                      </div>


                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>


  <!-- notshowing registration here anymore  -->
  <div class="column5 margin-top-10 colmd3" *ngIf="ShowList1" hidden>
    <div class="card height-100pe">

      <div class="card-header wh-header header3 padding-left-30px padding-right-32px bk-color-sky padding-bottom-0px padding-top-5px">
 

      </div>
      <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-sky">

 
        <div class="row" >
          <div class="position-fixed-Activities">

            <div class="col-md-12">
              <div class="card">
                <div class="card-header wh-header  padding-left-0px padding-right-0px border-bottom-0px padding-top-0px ">
                  <ul class="nav nav-tabs nav-tab-ivf margin-top-3px" id="tabContent">
                    <li class="active nav-link-hand margin-right-5px"><a class="nav-item-ivf active" href="#details" data-toggle="tab">Individual</a></li>
                    <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#access-security" data-toggle="tab">Donor</a></li>
                    <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#Forms" data-toggle="tab">Couple</a></li>
                  </ul>
                </div>
                <div class="card-body padding-all-0px">
                  <div class="tab-content">
                    <div class="tab-pane active" id="details">
                      <form class="form" novalidate="" (ngSubmit)="onSubmitIn()" #fin="ngForm">
                        <div class="card">
                          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                      Add New Patient

                      <button type="button" class="close" data-dismiss="modal"
                              (click)="activeModal.dismiss('Cross click')"
                              aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>-->
                          <div class="card-body padding-bottom-0px padding-top-3px">
                            <div>
                              <div class="row">
                                <div class="col-md-12">
                                  <button type="submit" [disabled]="!fin.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 ">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                        <span>*</span>Salutation (Name Prefix)


                                      </label>
                                    </div>
                                    <div class="col-md-12">

                                      <!--<input type="text" class="form-control" placeholder="Salutation"
                                       id="CurrentSavePatientInfoRequest.Salutation"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.Salutation"
                                       name="CurrentSavePatientInfoRequest.Salutation" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                       maxlength="20" minlength="1" #Salutation="ngModel" required>
                                <small class="form-text text-danger"
                                       *ngIf="(!Salutation.valid && (Salutation.dirty || Salutation.touched) && Salutation.errors.required )">(Field cannot be left blank)</small>
                                <small class="form-text text-danger"
                                       *ngIf="(!Salutation.valid && Salutation.errors.pattern)">(special characters are not allowed)</small>-->

                                      <CodeTypeValue CodeType="NPRE" id="CurrentSavePatientInfoRequest.Salutation"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                                     name="CurrentSavePatientInfoRequest.Salutation" required>

                                      </CodeTypeValue>
                                    </div>


                                  </div>

                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                    </div>
                                    <div class="col-md-12">

                                      <input type="text" class="form-control" placeholder="First Name"
                                             id="CurrentSavePatientInfoRequest.DisplayName"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                             name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                             maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>

                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 ">
                                      <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                    </div>
                                    <div class="col-md-12">
                                      <div class="date-form">
                                        <input type="text" class="form-control form-control-patient" placeholder="Date Of Birth"
                                               name="dp" [(ngModel)]="DateOfBirth" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #din="ngbDatepicker" #DOBin="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOBin.valid && (DOBin.dirty || DOBin.touched) && DOBin.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="din.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>
                                      <!--<div class="date-form">
                                  <input class="form-control form-control-patient" placeholder="Wedding Anniversary" [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp3" [(ngModel)]="DateOfBirth" ngbDatepicker #d4="ngbDatepicker" #DOBin="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!DOBin.valid && (DOBin.dirty || DOBin.touched) && DOBin.errors.required)">(Field cannot be left blank)</small>

                                  <a (click)="d4.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>

                                </div>-->
                                    </div>


                                  </div>
                                </div>

                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Sex</label>
                                    </div>

                                    <div class="col-md-12">
                                      <CodeTypeValue CodeType="Sex"
                                                     id="CurrentSavePatientInfoRequest.Gender"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Gender" SelectedValue=""
                                                     name="CurrentSavePatientInfoRequest.Gender" required>
                                      </CodeTypeValue>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number </label>
                                    </div>
                                    <div class="col-md-12">
                                      <input type="tel" class="form-control" placeholder="Mobile Phone"
                                             id="CurrentSavePatientInfoRequest.Telephone1"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                             mask="(000) 000-0000"
                                             name="CurrentSavePatientInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                                    </div>
                                    <div class="col-md-12">
                                      <!--<input type="text" class="form-control" placeholder="Address Line1"
                                       id="CurrentSavePatientInfoRequest.AddressLine1"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                       name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                       maxlength="100">
                                <small class="form-text text-danger"
                                       *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                                      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                                name="CurrentSavePatientInfoRequest.AddressLine1"
                                                [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                                #addconcerns_text1="ngModel"></textarea>
                                      <small class="form-text text-danger"
                                             *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>
                                    </div>
                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                          <!--<div class="card-footer">

                      <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
                    </div>-->
                        </div>
                      </form>


                    </div>
                    <div class="tab-pane" id="access-security">
                      <form class="form" novalidate="" (ngSubmit)="onDonor()" #fDo="ngForm">
                        <div class="card">
                          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                      Add New Donor

                      <button type="button" class="close" data-dismiss="modal"
                              (click)="activeModal.dismiss('Cross click')"
                              aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>-->
                          <div class="card-body padding-bottom-0px padding-top-3px">
                            <div class="row">
                              <div class="col-md-12">
                                <button type="submit" [disabled]="!fDo.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
                              </div>
                            </div>
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Donor Type</label>
                                  </div>

                                  <div class="col-md-12">
                                    <CodeTypeValue CodeType="DONTY"
                                                   id="CurrentSavePatientInfoRequest.DonorTypeName"
                                                   [(ngModel)]="CurrentSavePatientInfoRequest.DonorTypeName" SelectedValue=""
                                                   name="CurrentSavePatientInfoRequest.DonorTypeName" required>
                                    </CodeTypeValue>

                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                      <span>*</span>Salutation (Name Prefix)


                                    </label>
                                  </div>
                                  <div class="col-md-12">

                                    <!--<input type="text" class="form-control" placeholder="Salutation"
                                     id="CurrentSavePatientInfoRequest.Salutation"
                                     [(ngModel)]="CurrentSavePatientInfoRequest.Salutation"
                                     name="CurrentSavePatientInfoRequest.Salutation" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                     maxlength="20" minlength="1" #Salutation="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Salutation.valid && (Salutation.dirty || Salutation.touched) && Salutation.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Salutation.valid && Salutation.errors.pattern)">(special characters are not allowed)</small>-->
                                    <CodeTypeValue CodeType="NPRE"
                                                   id="CurrentSavePatientInfoRequest.Salutation"
                                                   [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                                   name="CurrentSavePatientInfoRequest.Salutation" required>
                                    </CodeTypeValue>

                                  </div>


                                </div>

                              </div>
                            </div>
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                  </div>
                                  <div class="col-md-12">

                                    <input type="text" class="form-control" placeholder="First Name"
                                           id="CurrentSavePatientInfoRequest.DisplayName"
                                           [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                           name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                           maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>

                                  </div>

                                </div>

                              </div>
                            </div>
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                  </div>
                                  <div class="col-md-12">
                                    <div class="date-form">
                                      <input class="form-control form-control-patient" placeholder="Date Of Birth"
                                             name="dp" [(ngModel)]="DateOfBirth" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d="ngbDatepicker" #DOB="ngModel">
                                      <small class="form-text text-danger"
                                             *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                      <a (click)="d.toggle()" class="nav-link-hand">
                                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                      </a>

                                    </div>
                                  </div>


                                </div>
                              </div>

                            </div>
                            <!--<div class="row my-profile-form">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-5 text-align-right">
                              <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Sex</label>
                            </div>

                            <div class="col-md-3">
                              <CodeTypeValue CodeType="Sex"
                                             id="CurrentSavePatientInfoRequest.Gender"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Gender" SelectedValue=""
                                             name="CurrentSavePatientInfoRequest.Gender">
                              </CodeTypeValue>

                            </div>
                          </div>


                        </div>
                      </div>-->
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number </label>
                                  </div>
                                  <div class="col-md-12">
                                    <input type="tel" class="form-control" placeholder="Mobile Phone"
                                           id="CurrentSavePatientInfoRequest.Telephone1"
                                           [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                           mask="(000) 000-0000"
                                           name="CurrentSavePatientInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                                    <small class="form-text text-danger"
                                           *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                  </div>
                                </div>


                              </div>
                            </div>

                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                                  </div>
                                  <div class="col-md-12">
                                    <!--<input type="text" class="form-control" placeholder="Address Line1"
                                     id="CurrentSavePatientInfoRequest.AddressLine1"
                                     [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                     name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                     maxlength="100">
                              <small class="form-text text-danger"
                                     *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                                    <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                              name="CurrentSavePatientInfoRequest.AddressLine1"
                                              [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                              #addconcerns_text1="ngModel"></textarea>
                                    <small class="form-text text-danger"
                                           *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>
                                  </div>
                                </div>


                              </div>
                            </div>



                          </div>
                          <!--<div class="card-footer">

                      <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
                    </div>-->
                        </div>
                      </form>
                    </div>
                    <div class="tab-pane" id="Forms">
                      <form class="form" novalidate="" (ngSubmit)="onCouple()" #fco="ngForm">
                        <div class="card">

                          <div class="card-body margin-left-0px padding-top-0px padding-right-0px padding-left-0px">
                            <div class="row">
                              <div class="col-md-12">
                                <button type="submit" [disabled]="!fco.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
                              </div>
                            </div>
                            <div class="col-md-12 padding-right-0px padding-left-0px">
                              <div class="chatsd product-chart-wrapper product-chat-height-527px agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                <div class="accordion" id="accordionExampleFemale">
                                  <div class="card margin-bottom-5px">
                                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFemale">
                                      <div class="row">
                                        <div class="col-md-12">
                                          <h5 class="mb-0 height-24px">
                                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFemale" aria-expanded="true" aria-controls="collapseFemale">
                                              Female Registration
                                            </button>
                                          </h5>
                                        </div>

                                      </div>


                                    </div>

                                    <div id="collapseFemale" class="collapse show" aria-labelledby="headingFemale" data-parent="#accordionExampleFemale">
                                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                        <div class="row margin-left-0px">
                                          <div class="col-md-12">
                                            <div class="card">
                                              <div class="card-body padding-all-0px margin-left-0px">
                                                <div class="row margin-top-5px my-profile-form">
                                                  <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                    <div class="row">
                                                      <div class="col-md-12">
                                                        <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                                          <span>*</span>Salutation (Name Prefix)


                                                        </label>
                                                      </div>



                                                    </div>
                                                    <div class="row">
                                                      <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                        <div class="row">

                                                          <div class="col-md-12 ">

                                                            <CodeTypeValue CodeType="FSAL"
                                                                           id="CurrentSavePatientInfoRequest.Salutation"
                                                                           [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                                                           name="CurrentSavePatientInfoRequest.Salutation">
                                                            </CodeTypeValue>


                                                          </div>


                                                        </div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="row my-profile-form margin-top-5px">
                                                  <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                    <div class="row">
                                                      <div class="col-md-12">
                                                        <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                                      </div>


                                                    </div>
                                                    <div class="row my-profile-form">
                                                      <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <input type="text" class="form-control" placeholder="First Name"
                                                                   id="CurrentSavePatientInfoRequest.DisplayName"
                                                                   [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                                                   name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                                                   maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                                            <small class="form-text text-danger"
                                                                   *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                                            <small class="form-text text-danger"
                                                                   *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                                          </div>


                                                        </div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="row margin-top-7px my-profile-form">
                                                  <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                    <div class="row">
                                                      <div class="col-md-12">
                                                        <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                                      </div>



                                                    </div>
                                                    <div class="row">
                                                      <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <div class="date-form">
                                                              <input class="form-control form-control-patient" placeholder="Date Of Birth"
                                                                     name="dpF" [(ngModel)]="FemaleDateofBirth" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" #dFe="ngbDatepicker" #DOB="ngModel">
                                                              <small class="form-text text-danger"
                                                                     *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                                              <a (click)="dFe.toggle()" class="nav-link-hand">
                                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                              </a>

                                                            </div>
                                                          </div>



                                                        </div>
                                                      </div>

                                                    </div>
                                                  </div>

                                                </div>
                                                <div class="row margin-top-7px my-profile-form">
                                                  <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                    <div class="row">
                                                      <div class="col-md-12">
                                                        <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number  </label>
                                                      </div>



                                                    </div>
                                                    <div class="row">
                                                      <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <input type="tel" class="form-control" placeholder="Mobile Phone"
                                                                   id="CurrentSavePatientInfoRequest.Telephone1"
                                                                   [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                                                   mask="(000) 000-0000"
                                                                   name="CurrentSavePatientInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                                                            <small class="form-text text-danger"
                                                                   *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                                          </div>



                                                        </div>
                                                      </div>

                                                    </div>
                                                  </div>

                                                </div>
                                              </div>
                                            </div>
                                          </div>


                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!--<div class="row margin-left-0px">

                            <div class="col-md-12 border-rt">
                              <div class="card">
                                <div class="card-header wh-header color-female-heading padding-right-0px padding-bottom-0px padding-left-0px">
                                  Female Registration
                                </div>

                              </div>




                            </div>



                          </div>-->
                                <div class="accordion" id="accordionExampleMale">
                                  <div class="card margin-bottom-5px">
                                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingMale">
                                      <div class="row">
                                        <div class="col-md-12">
                                          <h5 class="mb-0 height-24px">
                                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseMale" aria-expanded="true" aria-controls="collapseMale">
                                              Male Registration
                                            </button>
                                          </h5>
                                        </div>

                                      </div>


                                    </div>

                                    <div id="collapseMale" class="collapse show" aria-labelledby="headingMale" data-parent="#accordionExampleMale">
                                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                        <div class="row margin-left-0px">
                                          <div class="col-md-12">
                                            <div class="card">
                                              <div class="card-body padding-all-0px margin-left-0px">
                                                <div class="row margin-top-5px my-profile-form">
                                                  <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                    <div class="row">
                                                      <div class="col-md-12">
                                                        <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                                          <span>*</span>Salutation (Name Prefix)


                                                        </label>
                                                      </div>



                                                    </div>
                                                    <div class="row">
                                                      <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                        <div class="row">

                                                          <div class="col-md-12">

                                                            <CodeTypeValue CodeType="MSAL"
                                                                           id="CurrentSavePatientInfoRequest.SalutationMale"
                                                                           [(ngModel)]="CurrentSavePatientInfoRequest.SalutationMale" SelectedValue=""
                                                                           name="CurrentSavePatientInfoRequest.SalutationMale">
                                                            </CodeTypeValue>



                                                          </div>


                                                        </div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="row my-profile-form margin-top-5px">
                                                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                    <div class="row">
                                                      <div class="col-md-12">
                                                        <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                                      </div>


                                                    </div>
                                                    <div class="row my-profile-form">
                                                      <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <input type="text" class="form-control" placeholder="First Name"
                                                                   id="CurrentSavePatientInfoRequest.DisplayNameMale"
                                                                   [(ngModel)]="CurrentSavePatientInfoRequest.DisplayNameMale"
                                                                   name="CurrentSavePatientInfoRequest.DisplayNameMale" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                                                   maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                                            <small class="form-text text-danger"
                                                                   *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                                            <small class="form-text text-danger"
                                                                   *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                                          </div>


                                                        </div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="row margin-top-7px my-profile-form">
                                                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                    <div class="row">
                                                      <div class="col-md-12">
                                                        <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                                      </div>



                                                    </div>
                                                    <div class="row">
                                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <div class="date-form">
                                                              <input class="form-control form-control-patient" placeholder="Date Of Birth"
                                                                     name="dpM" [(ngModel)]="DateOfBirth" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" #dMe="ngbDatepicker" #DOB="ngModel">
                                                              <small class="form-text text-danger"
                                                                     *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                                              <a (click)="dMe.toggle()" class="nav-link-hand">
                                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                              </a>

                                                            </div>
                                                          </div>



                                                        </div>
                                                      </div>

                                                    </div>
                                                  </div>

                                                </div>

                                                <div class="row margin-top-7px my-profile-form">
                                                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                    <div class="row">
                                                      <div class="col-md-12">
                                                        <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number  </label>
                                                      </div>



                                                    </div>
                                                    <div class="row">
                                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <input type="tel" class="form-control" placeholder="Mobile Phone"
                                                                   id="CurrentSavePatientInfoRequest.MaleTelephone1"
                                                                   [(ngModel)]="CurrentSavePatientInfoRequest.MaleTelephone1"
                                                                   mask="(000) 000-0000"
                                                                   name="CurrentSavePatientInfoRequest.MaleTelephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                                                            <small class="form-text text-danger"
                                                                   *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                                          </div>



                                                        </div>
                                                      </div>

                                                    </div>
                                                  </div>

                                                </div>

                                              </div>
                                            </div>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="accordion" id="accordionExampleCommon">
                                  <div class="card margin-bottom-5px">
                                    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingCommon">
                                      <div class="row">
                                        <div class="col-md-12">
                                          <h5 class="mb-0 height-24px">
                                            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseCommon" aria-expanded="true" aria-controls="collapseCommon">
                                              Common Details
                                            </button>
                                          </h5>
                                        </div>

                                      </div>


                                    </div>

                                    <div id="collapseCommon" class="collapse show" aria-labelledby="headingCommon" data-parent="#accordionExampleCommon">
                                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                        <div class="row margin-top-0px background-pay margin-left-0px">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                                            <div class="row margin-top-10 margin-left-0px">
                                              <div class="col-md-12">
                                                <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                                              </div>
                                              <div class="col-md-12">
                                                <!--<input type="text" class="form-control" placeholder="Address Line1"
                                                 id="CurrentSavePatientInfoRequest.AddressLine1"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                                 maxlength="100">
                                          <small class="form-text text-danger"
                                                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                                                <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                                          name="CurrentSavePatientInfoRequest.AddressLine1"
                                                          [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                                          #addconcerns_text1="ngModel"></textarea>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))"></small>
                                              </div>
                                            </div>


                                          </div>
                                        </div>
                                        <div class="row background-pay margin-left-0px padding-bottom-10px">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                                            <div class="row margin-left-0px">
                                              <div class=" col-md-12 padding-right-0px">
                                                <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Wedding Anniversary</label>
                                              </div>
                                              <div class="col-md-12">
                                                <!--<input type="text" class="form-control" placeholder="Address Line1"
                                                 id="CurrentSavePatientInfoRequest.AddressLine1"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                                 maxlength="100">
                                          <small class="form-text text-danger"
                                                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                                                <!--<textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                                    name="CurrentSavePatientInfoRequest.AddressLine1"
                                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" required minlength="1" maxlength="100"
                                                    #addconcerns_text1="ngModel"></textarea>
                                          <small class="form-text text-danger"
                                                 *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>-->
                                                <div class="date-form">
                                                  <input class="form-control form-control-patient" placeholder="Wedding Anniversary" [minDate]="minDate" [maxDate]="maxDate"
                                                         name="dpw" [(ngModel)]="WeddingAn" ngbDatepicker #dw="ngbDatepicker" #DOB1="ngModel">
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!DOB1.valid && (DOB1.dirty || DOB1.touched) && DOB1.errors.required)">(Field cannot be left blank)</small>

                                                  <a (click)="dw.toggle()" class="nav-link-hand">
                                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                  </a>

                                                </div>
                                              </div>
                                            </div>


                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>

                          </div>
                          <!--<div class="card-footer">
                      <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                      <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
                    </div>-->
                        </div>
                        <div class="card top-link2">
                          <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                            Add New Couple

                            <button type="button" class="close" data-dismiss="modal"
                                    (click)="activeModal.dismiss('Cross click')"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="card-body margin-left-0px padding-top-0px">
                            <div class="col-md-12 col-12">
                              <div class="row">

                                <div class="col-md-4 col-12 border-rt padding-left-0px">
                                  <div class="card">
                                    <div class="card-header wh-header color-female-heading padding-right-0px padding-bottom-0px">
                                      Female Registration
                                    </div>

                                  </div>


                                  <!--<div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                                  </div>
                                  <div class="col-md-6">
                                    <input type="text" class="form-control" placeholder="Address Line1"
                                           id="CurrentSavePatientInfoRequest.AddressLine1"
                                           [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                           name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                           maxlength="100">
                                    <small class="form-text text-danger"
                                           *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>
                                  </div>
                                </div>


                              </div>
                            </div>-->

                                </div>
                                <!--<label>Male</label>-->


                              </div>
                              <div class="row">
                                <div class="col-md-3 col-12">
                                  <div class="card">
                                    <div class="card-body padding-all-0px margin-left-0px">
                                      <div class="row margin-top-5px">
                                        <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-12 col-12 text-align-right">
                                              <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                                <span>*</span>Salutation (Name Prefix)


                                              </label>
                                            </div>



                                          </div>
                                          <div class="row">
                                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                              <div class="row">

                                                <div class="col-md-12 col-12">

                                                  <CodeTypeValue CodeType="FSAL"
                                                                 id="CurrentSavePatientInfoRequest.Salutation"
                                                                 [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                                                 name="CurrentSavePatientInfoRequest.Salutation">
                                                  </CodeTypeValue>


                                                </div>


                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row my-profile-form margin-top-10">
                                        <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-12 col-12 text-align-right ">
                                              <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                            </div>


                                          </div>
                                          <div class="row my-profile-form">
                                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                              <div class="row">
                                                <div class="col-md-12 col-12">
                                                  <input type="text" class="form-control" placeholder="First Name"
                                                         id="CurrentSavePatientInfoRequest.DisplayName"
                                                         [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                                         name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                                         maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                                </div>


                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row margin-top-7px">
                                        <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-12 col-12 text-align-right ">
                                              <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                            </div>



                                          </div>
                                          <div class="row">
                                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                              <div class="row">
                                                <div class="col-md-12 col-12 text-align-right">
                                                  <div class="date-form">
                                                    <input class="form-control form-control-patient" placeholder="Date Of Birth" [minDate]="minDate" [maxDate]="maxDate"
                                                           name="dps" [(ngModel)]="FemaleDateofBirth" ngbDatepicker #d1="ngbDatepicker" #DOB="ngModel">
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                                    <a (click)="d1.toggle()" class="nav-link-hand">
                                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                    </a>

                                                  </div>
                                                </div>



                                              </div>
                                            </div>

                                          </div>
                                        </div>

                                      </div>
                                      <div class="row margin-top-7px">
                                        <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-12 col-12 text-align-right">
                                              <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number  </label>
                                            </div>



                                          </div>
                                          <div class="row">
                                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                              <div class="row">
                                                <div class="col-md-12 col-12 text-align-right">
                                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                                         id="CurrentSavePatientInfoRequest.Telephone1"
                                                         [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                                         mask="(000) 000-0000"
                                                         name="CurrentSavePatientInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                                </div>



                                              </div>
                                            </div>

                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>


                              </div>
                              <div class="row">

                                <div class="col-md-4 col-12 border-rt padding-left-0px">
                                  <div class="card">
                                    <div class="card-header wh-header color-male-heading padding-right-0px padding-bottom-0px">
                                      Male Registration
                                    </div>

                                  </div>


                                  <!--<div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                                  </div>
                                  <div class="col-md-6">
                                    <input type="text" class="form-control" placeholder="Address Line1"
                                           id="CurrentSavePatientInfoRequest.AddressLine1"
                                           [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                           name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                           maxlength="100">
                                    <small class="form-text text-danger"
                                           *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>
                                  </div>
                                </div>


                              </div>
                            </div>-->

                                </div>
                                <!--<label>Male</label>-->


                              </div>
                              <div class="row">
                                <div class="col-md-3 col-12">
                                  <div class="card">
                                    <div class="card-body padding-all-0px margin-left-0px">
                                      <div class="row margin-top-5px">
                                        <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-12 col-12 text-align-right">
                                              <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                                <span>*</span>Salutation (Name Prefix)


                                              </label>
                                            </div>



                                          </div>
                                          <div class="row">
                                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                              <div class="row">

                                                <div class="col-md-12">

                                                  <CodeTypeValue CodeType="MSAL"
                                                                 id="CurrentSavePatientInfoRequest.SalutationMale"
                                                                 [(ngModel)]="CurrentSavePatientInfoRequest.SalutationMale" SelectedValue=""
                                                                 name="CurrentSavePatientInfoRequest.SalutationMale">
                                                  </CodeTypeValue>



                                                </div>


                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="row my-profile-form margin-top-10">
                                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-12 text-align-right">
                                              <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                            </div>


                                          </div>
                                          <div class="row my-profile-form">
                                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                              <div class="row">
                                                <div class="col-md-12">
                                                  <input type="text" class="form-control" placeholder="First Name"
                                                         id="CurrentSavePatientInfoRequest.DisplayNameMale"
                                                         [(ngModel)]="CurrentSavePatientInfoRequest.DisplayNameMale"
                                                         name="CurrentSavePatientInfoRequest.DisplayNameMale" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                                         maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                                </div>


                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="row margin-top-7px">
                                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-12 text-align-right">
                                              <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                            </div>



                                          </div>
                                          <div class="row">
                                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                              <div class="row">
                                                <div class="col-md-12 text-align-right">
                                                  <div class="date-form">
                                                    <input class="form-control form-control-patient" placeholder="Date Of Birth" [minDate]="minDate" [maxDate]="maxDate"
                                                           name="dp2" [(ngModel)]="DateOfBirth" ngbDatepicker #d2="ngbDatepicker" #DOB="ngModel">
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                                    <a (click)="d2.toggle()" class="nav-link-hand">
                                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                    </a>

                                                  </div>
                                                </div>



                                              </div>
                                            </div>

                                          </div>
                                        </div>

                                      </div>

                                      <div class="row margin-top-7px">
                                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-12 text-align-right">
                                              <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number  </label>
                                            </div>



                                          </div>
                                          <div class="row">
                                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                              <div class="row">
                                                <div class="col-md-12 text-align-right">
                                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                                         id="CurrentSavePatientInfoRequest.MaleTelephone1"
                                                         [(ngModel)]="CurrentSavePatientInfoRequest.MaleTelephone1"
                                                         mask="(000) 000-0000"
                                                         name="CurrentSavePatientInfoRequest.MaleTelephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                                </div>



                                              </div>
                                            </div>

                                          </div>
                                        </div>

                                      </div>

                                    </div>
                                  </div>
                                </div>

                              </div>
                              <div class="row margin-top-10 background-pay">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                                  <div class="row margin-top-10 margin-left-0px">
                                    <div class="col-md-3 text-align-right">
                                      <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                                    </div>
                                    <div class="col-md-6">
                                      <!--<input type="text" class="form-control" placeholder="Address Line1"
                                       id="CurrentSavePatientInfoRequest.AddressLine1"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                       name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                       maxlength="100">
                                <small class="form-text text-danger"
                                       *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                                      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                                name="CurrentSavePatientInfoRequest.AddressLine1"
                                                [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                                #addconcerns_text1="ngModel"></textarea>
                                      <small class="form-text text-danger"
                                             *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))"></small>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row background-pay">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                                  <div class="row margin-left-0px">
                                    <div class=" col-md-3 text-align-right padding-right-0px">
                                      <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Wedding Anniversary</label>
                                    </div>
                                    <div class="col-md-3">
                                      <!--<input type="text" class="form-control" placeholder="Address Line1"
                                       id="CurrentSavePatientInfoRequest.AddressLine1"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                       name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                       maxlength="100">
                                <small class="form-text text-danger"
                                       *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                          name="CurrentSavePatientInfoRequest.AddressLine1"
                                          [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" required minlength="1" maxlength="100"
                                          #addconcerns_text1="ngModel"></textarea>
                                <small class="form-text text-danger"
                                       *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>-->
                                      <div class="date-form">
                                        <input class="form-control form-control-patient" placeholder="Wedding Anniversary" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp3" [(ngModel)]="WeddingAn" ngbDatepicker #d4="ngbDatepicker" #DOB="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d4.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>
                                    </div>
                                  </div>


                                </div>
                              </div>
                            </div>

                          </div>
                          <div class="card-footer">
                            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                            <button type="submit" [disabled]="!fco.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
    
        </div>

      </div>

    </div>
    
  </div>



  <div class="column3" *ngIf="AppList" hidden>
    <div class="card">

      <div class="card-header wh-header header3 padding-left-30px padding-right-32px bk-color-sky padding-bottom-0px">
        <div class="row nav-link-hand">

          <label class="font-size-16px labcolor padding-bottom-0px margin-bottom-0px bk-color-sky">
            Appointments of the day
          </label>


        </div>
        <div class="row nav-link-hand">

          <label class="wh-header labcolor font-weight-normal border-radius-4px padding-bottom-0px margin-bottom-0px bk-color-sky">
            25 May 2019
          </label>


        </div>

      </div>
      <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-sky">

        <div class="row padding-top-5px padding-bottom-10px margin-right-0px margin-left-5px padding-left-10px">
          <input type="search" class="form-control padding-bottom-2px width-271px" placeholder="Search....">


        </div>
        <div>
          <div class="chatsd product-chart-wrapper product-chat-height-569 agreement-chart-wrapper ps2 padding-lrt ">
            <div class="row rowfor margin-left-0px margin-right-0px   edit_hover_class">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>



                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>

                <div class="row">
                  <div class="offset-md-8 col-md-4">
                    <div class="row">
                      <div class="col-md-4">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-4">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-4">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>
                  </div>
                </div>




              </div>

            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>



</div>
